export default "https://cdn-static.gokick.com/assets/ac567471f1b9fb2f6cedfba22f3391469dbaa38e/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";